// components/TeammateProducts.jsx - Teammate Products Container
import React from 'react';
import TeammateTableHeader from './TeammateTableHeader';
import TeammateProductRow from './TeammateProductRow';

const TeammateProducts = ({ displayProducts, user, translate, onDelete, deleteThisProductId }) => {
  return (
    <div className='teammate-products-container'>
      <TeammateTableHeader translate={translate} />
      <div className='teammate-products-list'>
        {displayProducts.map((product, index) => (
          <TeammateProductRow
            key={product['customers_basket_id']}
            product={product}
            index={index}
            translate={translate}
            onDelete={onDelete}
            deleteThisProductId={deleteThisProductId}
          />
        ))}
      </div>
    </div>
  );
};

export default TeammateProducts;
